import CompanionGroup from "./CompanionGroup";

/**
 * Provides central object to store any CompanionGroup
 * objects used for synchronizing render refreshes
 * for a set of ads.
 *
 * @class
 */
class CompanionGroupCoordinator {

    private _all: Record<string, CompanionGroup> = {};

    /**
     * Returns an existing CompanionGroup by id or
     * creates a new one if not found
     */
    findOrCreate(id: string): CompanionGroup {
        let companionGroup = this._all[id];

        if (!companionGroup) {
            companionGroup = new CompanionGroup();
            this._all[id] = companionGroup;
        }

        return companionGroup;
    }

    /**
     * Finds an existing CompanionGroup
     */
    find(id: string): CompanionGroup {
        return this._all[id];
    }

    /**
     * Clear all entries from this instance
     * of CompanionGroupCoordinator and all the underlying
     * parent/children pairs.
     */
    clearAll(): void {
        this.clearAllChildren();
        this.clearAllParents();
        this._all = {};
    }

    /**
     * Clears all children from all CompanionGroups
     * in this CompanionGroupCoordinator
     */
    clearAllChildren(): void {
        const pairs = Object.keys(this._all);

        pairs.forEach((companionId) => {
            this._all[companionId].clearChildren();
        });
    }

    /**
     * Clears all parents from all CompanionGroups
     * in this CompanionGroupCoordinator
     */
    clearAllParents(): void {
        const pairs = Object.keys(this._all);

        pairs.forEach((companionId) => {
            this._all[companionId].clearParent();
        });
    }

    destroy(): void {
        this.clearAll();
    }

}

export default CompanionGroupCoordinator;
